import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar } from '../sidebar/Sidebar';
import { SidebarProvider } from '../../../contexts/SidebarContext';
import styles from './layout.module.css';
import { Outlet } from "react-router-dom";

export const Layout = ({
  onNavigate
}) => {
  return (
    <SidebarProvider>
      <div className={styles.layout}>
        {/* <Sidebar onNavigate={onNavigate} /> */}

        <div className={styles.main}>
          <main className={styles.content}>
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

Layout.propTypes = {
  onNavigate: PropTypes.func
};
